import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { authManager } from '../utils/auth';

const Base_Url = process.env.REACT_APP_API_BASE_URL;

function ServiceBenefits() {
    const [benefits, setBenefits] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({});
    const [deleteId, setDeleteId] = useState(null);
    const [deleting, setDeleting] = useState(false);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        fetchBenefits();
    }, []);

    const fetchBenefits = async (page = 1) => {
        try {
            setLoading(true);
            const res = await authManager.authenticatedFetch(
                `${Base_Url}/membership/benefits/list?page=${page}&limit=10`
            );
            const data = await res.json();

            if (data.status === 'success') {
                setBenefits(data.data.benefits || []);
                setPagination(data.data.pagination || {});
            } else {
                toast.error(data.message || 'Failed to fetch benefits');
            }
        } catch (error) {
            console.error('Error fetching benefits:', error);
            toast.error('Error fetching benefits');
        } finally {
            setLoading(false);
        }
    };

    const handleToggleVisibility = async (id, isActive) => {
        try {
            const benefit = benefits.find(b => b._id === id);
            const updatedPayload = {
                ...benefit,
                status: isActive ? 'inactive' : 'active'
            };

            const res = await authManager.authenticatedFetch(
                `${Base_Url}/membership/benefits/${id}`,
                {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(updatedPayload)
                }
            );

            const data = await res.json();
            if (data.status === 'success') {
                toast.success('Visibility updated successfully');
                fetchBenefits(pagination.page || 1);
            } else {
                toast.error(data.message || 'Update failed');
            }
        } catch (error) {
            console.error('Error updating visibility:', error);
            toast.error('Error updating visibility');
        }
    };

    const handleDelete = async () => {
        try {
            setDeleting(true);
            const res = await authManager.authenticatedFetch(
                `${Base_Url}/membership/benefits/${deleteId}`,
                { method: 'DELETE' }
            );

            const data = await res.json();
            if (data.status === 'success') {
                toast.success('Benefit deleted successfully');
                setDeleteId(null);
                window.$?.('#modaldelete_benefit').modal('hide');
                fetchBenefits(pagination.page || 1);
            } else {
                toast.error(data.message || 'Delete failed');
            }
        } catch (error) {
            console.error('Error deleting benefit:', error);
            toast.error('Error deleting benefit');
        } finally {
            setDeleting(false);
        }
    };

    return (

        <>
            <ToastContainer autoClose={3000} />
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 txt_lft">Service Benefits</h1>
                        </div>
                        <div className="col-sm-6 txt_rgt">
                            <Link to="/serviceBenefitsAdd" className="btn btn-blue">
                                Add Service Benefit
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="table-responsive">
                                {loading ? (
                                    <div className="text-center p-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                ) : benefits.length > 0 ? (
                                    <>
                                    <table width="100%" className="table table-striped table-bordered txt_lft">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Service Benefits</th>
                                                <th>Visibility</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {benefits.map((benefit, index) => (
                                                <tr key={benefit._id}>
                                                    <td>{((pagination.page || 1) - 1) * (pagination.limit || 10) + index + 1}</td>
                                                    <td>{benefit.circleOneBenefits?.serviceName || 'N/A'}</td>
                                                    <td align="center">
                                                        {/* <input
                                                            type="checkbox"
                                                            checked={benefit.status === 'active'}
                                                            onChange={() => handleToggleVisibility(benefit._id, benefit.status === 'active')}
                                                            data-toggle="toggle"
                                                            data-onstyle="success"
                                                            data-offstyle="danger"
                                                            data-width={50}
                                                            data-size="xs"
                                                        /> */}
                                                        <div className="toggle-switch">
                                                            <label className="switch">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={benefit.status === 'active'}
                                                                    onChange={() => handleToggleVisibility(benefit._id, benefit.status === 'active')}
                                                                />
                                                                <span className="slider"></span>
                                                            </label>
                                                            <span className="toggle-label">
                                                                {benefit.status === 'active' ? 'On' : 'Off'}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div align="center">
                                                            <Link to={`/serviceBenefitsView/${benefit._id}`} className="crsr_pntr">
                                                                <i className="fa-solid fa-eye mr-2" title="View" />
                                                            </Link>
                                                            <Link to={`/serviceBenefitsAdd/${benefit._id}`} className="crsr_pntr">
                                                                <i className="fa-solid fa-pen mr-2" title="Edit" />
                                                            </Link>
                                                            <button
                                                                className="crsr_pntr btn btn-link p-0"
                                                                onClick={() => setDeleteId(benefit._id)}
                                                                data-toggle="modal"
                                                                data-target="#modaldelete_benefit"
                                                            >
                                                                <i className="fa-solid fa-trash-can" title="Delete" />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    {/* Pagination */}
                                    {pagination.pages > 1 && (
                                        <nav className="mt-3">
                                            <ul className="pagination justify-content-center">
                                                <li className={`page-item ${pagination.page === 1 ? 'disabled' : ''}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => fetchBenefits(pagination.page - 1)}
                                                        disabled={pagination.page === 1}
                                                    >
                                                        Previous
                                                    </button>
                                                </li>
                                                {[...Array(pagination.pages)].map((_, i) => (
                                                    <li key={i} className={`page-item ${pagination.page === i + 1 ? 'active' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => fetchBenefits(i + 1)}
                                                        >
                                                            {i + 1}
                                                        </button>
                                                    </li>
                                                ))}
                                                <li className={`page-item ${pagination.page === pagination.pages ? 'disabled' : ''}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => fetchBenefits(pagination.page + 1)}
                                                        disabled={pagination.page === pagination.pages}
                                                    >
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    )}
                                    </>
                                ) : (
                                    <div className="text-center p-5">
                                        <p>No benefits found</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modaldelete_benefit" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirm Delete</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this benefit?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={handleDelete}
                                disabled={deleting}
                            >
                                {deleting ? 'Deleting...' : 'Delete'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServiceBenefits